import { render } from "./ViewedByFriendsCard.vue?vue&type=template&id=38d387d1&scoped=true"
import script from "./ViewedByFriendsCard.vue?vue&type=script&lang=js"
export * from "./ViewedByFriendsCard.vue?vue&type=script&lang=js"

import "./ViewedByFriendsCard.vue?vue&type=style&index=0&id=38d387d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d387d1"]])

export default __exports__